// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentPage_wrapper__wESl2"};